import store from '../../store/index';
import Helper from '../../helpers/helper';

import { appActions } from '../../helpers/constants';
import { hideModal, showModal } from '../../actions/modal/modal';

export const reAuthUser = () => {
  return dispatch => {

    const userInfo = JSON.parse(localStorage.getItem('User_Auth_Tokens'));

    if (!userInfo) return false;

    Helper.makeRequest('data/users', 'GET', userInfo?.token, null, userInfo?.userId)
    .then(Response => {
      if (!Response.ok) return Promise.reject(Response);
      
      return Response.json();
    })
    .then(json => {  
      dispatch({
        type: appActions.USER_REAUTH_SUCCESS,
        payload: json // Only sending json to reducer as other methods return a JWT at root of response.
      });

      dispatch(hideModal());
    })
    .catch(Response => {
      if (Response.text) return Response.text();

    }).then(text => {
      if (text === undefined) return false;

      dispatch({ type: appActions.USER_REAUTH_FAIL });

      const errors = Helper.handleErrorResponse(text);

      Helper.setNotification('danger', 'Error', `Unable to sign in: ${ errors }`);
      
      localStorage.removeItem('User_Auth_Tokens');
    })
    .finally(() => dispatch(setAppLoadingState(false)));

  }
}

export const createAccount = userData => {
  return dispatch => {

    const app = store.getState().app,
          isAuthed = app.isUserAuthenticated,
          userInfo = JSON.parse(localStorage.getItem('User_Auth_Tokens'));

    dispatch(setAppLoadingState(true));
    
    Helper.makeRequest('data/users', 'POST', isAuthed ? userInfo?.token : null, userData, null) // If admin creating another account, JWT token needs to be present
    .then(Response => {
      if (!Response.ok) return Promise.reject(Response);
        
      return Response.json();
    }).then(json => {
      dispatch(hideModal());
 
      if (isAuthed) dispatch({ type: appActions.CREATE_SEPARATE_ACCOUNT_SUCCESS }); // An admin is creating a new account for someone else
      else { // User is creating a new account for themselves.
        localStorage.setItem('User_Auth_Tokens',
          JSON.stringify({
            userId: json.user.user.id,
            token: json.token
          })
        );

        dispatch({
          type: appActions.NEW_USER_SUCCESS,
          payload: json.user
        });
      }

      Helper.setNotification('success', 'Success', 'Account created successfully');
    })
    .catch(Response => {
      if (Response.text) return Response.text();

    }).then(text => {
      if (text === undefined) return false;

      if (isAuthed) dispatch({ type: appActions.CREATE_SEPARATE_ACCOUNT_FAIL });
      else dispatch({ type: appActions.NEW_USER_FAIL });

      const errors = Helper.handleErrorResponse(text);

      Helper.setNotification('danger', 'Error', errors);
    })
    .finally(() => dispatch(setAppLoadingState(false)));
    
  }
}

export const userSignIn = userData => {
  return dispatch => {

    dispatch(setAppLoadingState(true));

    Helper.makeRequest('auth/login', 'POST', null, userData, null)
    .then(Response => {
      if (!Response.ok) return Promise.reject(Response);
      
      return Response.json();
    })
    .then(json => {
      dispatch(hideModal());
      
      localStorage.setItem('User_Auth_Tokens',
        JSON.stringify({
          userId: json.user.user.id,
          token: json.token
        })
      );

      dispatch({
        type: appActions.USER_AUTH_SUCCESS,
        payload: json.user
      });
 
      const salutation =
        json.user.user.first_name !== '' ?
          json.user.user.first_name :
          json.user.user.email
      
      Helper.setNotification('info', 'Welcome,', salutation, false);
    })
    .catch(Response => {
      if (Response.text) return Response.text();

    }).then(text => {
      if (text === undefined) return false;

      const errors = Helper.handleErrorResponse(text);

      dispatch({ type: appActions.USER_AUTH_FAIL });

      Helper.setNotification('danger', 'Invalid login', errors);
    })
    .finally(() => dispatch(setAppLoadingState(false)));

  }
}

export const userLogOut = () => {
  return dispatch => {

    dispatch({ type: appActions.USER_LOG_OUT });

    localStorage.removeItem('User_Auth_Tokens');

    Helper.setNotification('info', '', 'You have been signed out.', false);

  }
}

export const getApplicationLinks = () => {
  return dispatch => {

    Helper.makeRequest('links')
    .then(Response => {
      if (!Response.ok) return Promise.reject(Response);
      
      return Response.json();
    })
    .then(json => {
      dispatch({
        type: appActions.GET_APPLICATION_LINKS,
        payload: json
      });
    })
    .catch(Response => {
      if (Response.text) return Response.text();

    }).then(text => {
      if (text === undefined) return false;

      const errors = Helper.handleErrorResponse(text);

      Helper.setNotification('danger', 'Error', errors);
    })
    .finally(() => dispatch(setAppLoadingState(false)));
  }
}

export const editUser = (userId, userData) => {
  return dispatch => {

    dispatch(setAppLoadingState(true));

    const userInfo = JSON.parse(localStorage.getItem('User_Auth_Tokens'));
    
    Helper.makeRequest(`data/users/${ userId }`, 'PUT', userInfo.token, userData)
    .then(Response => {
      if (!Response.ok) return Promise.reject(Response);
        
      return Response.json();
    }).then(json => {
      const mainview = store.getState().mainview;
      const app = store.getState().app;

      if (mainview.userAccountListData) { // User edited another account/their account from account management screen
        dispatch(showModal('AccountManagement'));

        if (json.user.id === app.loggedInUser.user.id) dispatch(reAuthUser()); // Re-auth user if same account was updated from manage accounts screen
      }
      else { // User edited their own account from sidebar
        dispatch(reAuthUser());
        dispatch(hideModal());
      } 

      Helper.setNotification('success', 'Success', 'Account updated successfully');
    })
    .catch(Response => {
      if (Response.text) return Response.text();

    }).then(text => {
      if (text === undefined) return false;

      const errors = Helper.handleErrorResponse(text);
      
      dispatch({ type: appActions.EDIT_USER_ACCOUNT_FAIL });

      Helper.setNotification('danger', 'Error', errors);
    })
    .finally(() => dispatch(setAppLoadingState(false)));

  }
}

export const deleteUser = account => {
  return dispatch => {
    
    dispatch(setAppLoadingState(true));

    const userInfo = JSON.parse(localStorage.getItem('User_Auth_Tokens'));
    
    Helper.makeRequest(`data/users/${ account.user.id }`, 'DELETE', userInfo?.token)
    .then(Response => {
      if (!Response.ok) return Promise.reject(Response);
        
      Helper.setNotification('success', 'Success', 'Account deleted successfully');
      dispatch({ type: appActions.DELETE_ACCOUNT_SUCCESS });
    })
    .catch(Response => {
      if (Response.text) return Response.text();
      
    }).then(text => {
      if (text === undefined) return false;

      const errors = Helper.handleErrorResponse(text);
      
      dispatch({ type: appActions.DELETE_ACCOUNT_FAIL });

      Helper.setNotification('danger', 'Error', errors);
    })
    .finally(() => dispatch(setAppLoadingState(false)));

  }
}

export const resetPassword = data => {
  return dispatch => {

    dispatch(setAppLoadingState(true));

    Helper.makeRequest('auth/password/reset', 'POST', null, data)
    .then(Response => {
      if (!Response.ok) return Promise.reject(Response);
        
      return Response.json();
    }).then(() => {
      Helper.setNotification('success', 'Success', 'Password reset email successfully sent');
    })
    .catch(Response => {
      if (Response.text) return Response.text();

    }).then(text => {
      if (text === undefined) return false;

      const errors = Helper.handleErrorResponse(text);

      Helper.setNotification('danger', 'Error', errors);
    })
    .finally(() => dispatch(setAppLoadingState(false)));

  }
}

export const setAppLoadingState = isLoading => ({
  type: appActions.APP_LOADING,
  payload: isLoading
});